import React, {FC} from 'react';

import {useAppSelector} from '../../../helpers/reduxHelpers';
import {getHasModernFrame} from '../../../store/featureFlags/featureFlagsSelectors';
import {DeprecatedFrame} from './deprecatedFrame';
import {FrameProps} from './frameHelpers';
import {ModernFrame} from './modernFrame';

export const Frame: FC<FrameProps> = (props) => {
  const hasModernFrame = useAppSelector(getHasModernFrame);

  if (hasModernFrame) {
    return <ModernFrame {...props} />;
  }

  return <DeprecatedFrame {...props} />;
};
